var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"save-modal"}},[_c('button',{staticClass:"button-primary button-save-modal ml-2 mr-2 pl-3 pr-3",attrs:{"disabled":_vm.disabled,"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"cta"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }